import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
    const value = cell.getValue();
    const orderedIcon = cygnusSpriteHtml('check-circle', { variant: 'solid', className: 'text-success pe-2', title: 'Ordered' });
    const quotedIcon = cygnusSpriteHtml('x-circle', { variant: 'solid', className: 'text-warning-emphasis pe-2', title: 'Quoted' });

    if (!value || (Array.isArray(value) && value.length === 0)) {
        return '';
    }

    const el = document.createElement('div');
    el.classList.add('d-flex', 'flex-column', 'align-items-center');

    let html = `<div>
    ${value.map((value) => value.includes('Order') ? orderedIcon : '').join('')}
    ${value.map((value) => value.includes('Quote') ? quotedIcon : '').join('')}
  </div>`;

    el.innerHTML = html;
    return el;
}
